import * as types from './actionTypes';

export const createGame = (id) => ({
	type: types.GAME_CREATE,
	payload: {
		//todo this could be moved to the createGame call...
		id: 'game' + id,
		dateStarted: id,
		rounds: [],
		players: []
	}
});

export const setCurrentGame = (id) => ({
	type: types.GAME_SET_CURRENT,
	payload: {
		id
	}
})

export const gameAddRound = (gameId, roundId, roundIndex = 0) => ({
	type: types.GAME_ADD_ROUND,
	payload: { gameId, roundId, roundIndex }
});

export const gameAddPlayer = (gameId, playerId) => ({
	type: types.GAME_ADD_PLAYER,
	payload: { gameId, playerId }
});

//todo
// export const gameRemovePlayer

export const playerCreate = name => ({
	type: types.PLAYER_CREATE,
	payload: {
		id: 'player' + Date.now(),
		name
	}
});

export const playerEditName = (id, name) => ({
	type: types.PLAYER_EDIT_NAME,
	payload: {
		id,
		name
	}
});

export const setCurrentRound = (currentRoundId) => ({
	type: types.ROUND_SET,
	payload: {
		currentRoundId
	}
});


export const roundCreate = (roundId, index) => ({
	type: types.ROUND_CREATE,
	payload: {
		roundId,
		index,
		stacks: []
	}
});

export const roundAddStack = (roundId, stackId) => ({
	type: types.ROUND_ADD_STACK,
	payload: {
		roundId,
		stackId
	}
});

export const roundRemoveStack = (roundId, stackId) => ({
	type: types.ROUND_REMOVE_STACK,
	payload: {
		roundId,
		stackId
	}
});

//todo this could be created with default card values
//allow passing through value, cards, etc
export const stackCreate = (id, owner) => ({
	type: types.STACK_CREATE,
	payload: {
		id,
		cards: [{cardId: 'baseball_cards', count: 2}],
		owner,
		goldCount: 0,
		silverCount: 0,
		value: 0
	}
});

export const stackDelete = (stackId) => ({
	type: types.STACK_DELETE,
	payload: {
		stackId
	}
})

/**
 * add a card to the stack
 * @param {string} stackId stack to add the card to
 * @param {string} cardId card id to add
 */
export const stackAddCard = (stackId, cardId, count) => ({
	type: types.STACK_ADD_CARD,
	payload: {
		stackId,
		cardId,
		count
	}
});

export const stackEditGold = (stackId, goldCount) => ({
	type: types.STACK_EDIT_GOLD,
	payload: {
		stackId,
		goldCount
	}
});

export const stackEditSilver = (stackId, silverCount) => ({
	type: types.STACK_EDIT_SILVER,
	payload: {
		stackId,
		silverCount
	}
});
